import React, { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { SvgNoSendouts } from 'UI/res';

import { addLabelsAndFlattenData } from '../UserToolReports.utils';

import { COACH_MAP, columns, MAIN_COLUMN_ID } from './columns';
import { Header } from './Header';
import { Row } from './Row';
import { useStyles } from './styles';

const DataTable = ({ items, lastUpdates, queryParams }) => {
  const classes = useStyles();
  const areValidItems = Array.isArray(items) && items.length > 0;

  const data = useMemo(
    () => (areValidItems ? addLabelsAndFlattenData(items) : []),
    [areValidItems, items]
  );

  return areValidItems ? (
    <>
      <Header lastUpdates={lastUpdates} />

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={classes.teamHeaderCell} />

              {columns.map(col => (
                <TableCell
                  key={col.id}
                  className={clsx(classes.stickyHeader, {
                    [classes.stickyColumn]: col.id === MAIN_COLUMN_ID,
                    [classes.teamHeaderCell]: col.id === MAIN_COLUMN_ID,
                    [classes.headerInnerDayCell]: col.isDayColumn
                  })}
                >
                  <div className={classes.formattedText}>{col.label}</div>
                  {col.subLabel && <Typography variant="caption">{col.subLabel}</Typography>}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, index) => (
              <Row
                key={row.team === COACH_MAP.gpac ? `${row.team}_${index}` : row.team}
                columns={columns}
                queryParams={queryParams}
                row={row}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  ) : (
    <EmptyPlaceholder
      title={strings.shared.emptyState.title}
      subtitle={strings.shared.emptyState.subtitle}
      customEmptyState={<SvgNoSendouts height={400} />}
    />
  );
};
export default DataTable;
